export default __webpack_public_path__ + "static/instaconnect-d4afdb9e2f596f3a5db774befb03e8fd.png";